/*
 * pl-coupon-spot.js
 * ------------------------------------------------------------
 * Aplica o cupom da PDP sem sair da pagina e mantem o rotulo SEMPRE
 * igual ao carrinho de verdade.
 *
 * O elemento nasce como <a href="/discount/CODIGO?redirect=..."> e funciona
 * sozinho: sem JS o clique navega, a Shopify grava o cookie e devolve o
 * cliente para a mesma pagina. Este arquivo troca isso por um fetch silencioso
 * e reconcilia o estado com o carrinho.
 *
 * APLICA SO NO CARRINHO ATUAL (11/09). Ate aqui o clique chamava /discount/,
 * que grava o cookie `discount_code` (~2 semanas) e faz a Shopify reaplicar o
 * cupom em TODO carrinho novo: quem clicava uma vez nunca mais precisava
 * clicar, em nenhuma compra (mesmo mecanismo do caso DRJONATAS). Agora o
 * clique usa /cart/update.js — o codigo fica guardado no carrinho, vale mesmo
 * com o carrinho ainda vazio, e a proxima compra nasce limpa. Medido 11/09:
 *   carrinho vazio + update.js -> codigo guardado; ao adicionar, aplicavel
 *   nenhum cookie `discount_code` gravado (so o `cart`)
 *   carrinho novo no mesmo navegador -> nenhum codigo: tem de clicar de novo
 * Sem JS (ou com Cmd/Ctrl-clique) continua caindo no /discount/ — raro.
 *
 * FONTE DA VERDADE = /cart.js (medido em 25/08):
 *   - O carrinho responde `discount_codes` mesmo VAZIO, desde que o cookie do
 *     /discount esteja ativo. (A v1 assumia o contrario e por isso dependia so
 *     do localStorage — que descolava da realidade se o cliente removesse o
 *     cupom, se ele fosse desativado no admin, ou se limpasse os cookies.)
 *   - Zerar o carrinho NAO apaga o cupom: quem guarda e o cookie (~2 semanas).
 *
 * ZERO REQUISICAO NOVA: o proprio tema ja busca /cart.js 3x no load da PDP.
 * Em vez de buscar de novo, envelopamos window.fetch e lemos a resposta que
 * ja ia acontecer — mesmo padrao que o pl-cart-minimum-order.js usa.
 *
 * O localStorage continua, mas rebaixado: serve so para pintar o estado certo
 * no primeiro frame e evitar piscada ate a primeira resposta de carrinho
 * chegar. Quem manda e sempre o carrinho.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__plCouponSpotInit) return;
  window.__plCouponSpotInit = true;

  var STORE_PREFIX = 'pl_coupon_';
  var TTL_MS = 14 * 24 * 60 * 60 * 1000; // so dica de 1o frame; quem manda e o carrinho
  var TIMEOUT_MS = 8000;

  function storeKey(code) { return STORE_PREFIX + String(code || '').toUpperCase(); }

  // Sem valor gravado = ainda nao clicou. Nao e "erro" nem "cliente novo":
  // o certo nesse caso e mostrar a oferta ate o carrinho dizer o contrario.
  function lembrado(code) {
    try {
      var raw = window.localStorage.getItem(storeKey(code));
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (!ts || Date.now() - ts > TTL_MS) { esquecer(code); return false; }
      return true;
    } catch (e) { return false; }
  }
  function lembrar(code) {
    try { window.localStorage.setItem(storeKey(code), String(Date.now())); } catch (e) {}
  }
  function esquecer(code) {
    try { window.localStorage.removeItem(storeKey(code)); } catch (e) {}
  }

  // ---------- render ----------
  function pintarAplicado(el) {
    if (el.getAttribute('data-state') === 'applied') return; // ja esta assim
    var code = el.getAttribute('data-code') || '';
    var label = el.getAttribute('data-applied-label') || 'Cupom aplicado';

    var done = document.createElement('span');
    done.className = 'pl-coupon-spot__done';

    var check = document.createElement('span');
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';

    var text = document.createElement('span');
    text.textContent = label + ' ' + code; // textContent sempre: setting nunca vira HTML

    done.appendChild(check);
    done.appendChild(text);

    el.textContent = '';
    el.appendChild(done);
    el.setAttribute('data-state', 'applied');
    el.removeAttribute('aria-busy');
  }

  function pintarOferta(el) {
    if (el.getAttribute('data-state') !== 'applied') return; // ja esta oferecendo
    el.innerHTML = el.__plOfertaHTML || '';  // markup original, capturado no init
    el.removeAttribute('data-state');
    el.removeAttribute('aria-busy');
  }

  // ---------- reconciliacao com o carrinho ----------
  // PRESENCA do codigo, de proposito — NAO olhar `applicable`.
  // Medido em 25/08: `applicable` responde "esta descontando agora", nao "o
  // cliente tem o cupom". Com o carrinho VAZIO ele vem `false` para TODOS os
  // codigos, inclusive o AVISTA10OFF que sempre vale. Como a maioria das visitas
  // a PDP tem carrinho vazio, filtrar por `applicable` faria o rotulo voltar a
  // oferecer para quem ja tem o cupom, e so virar "aplicado" depois de adicionar
  // algo. O codigo estar na lista JA significa que o cliente o carrega.
  function cupomAtivo(cart, code) {
    var alvo = String(code || '').toUpperCase();
    return (cart.discount_codes || []).some(function (d) {
      return String(d.code || '').toUpperCase() === alvo;
    });
  }

  function reconciliar(cart) {
    if (!cart || !cart.discount_codes) return; // resposta que nao e carrinho
    document.querySelectorAll('pl-coupon-spot').forEach(function (el) {
      var code = el.getAttribute('data-code');
      if (!code) return;
      if (cupomAtivo(cart, code)) { lembrar(code); pintarAplicado(el); }
      else { esquecer(code); pintarOferta(el); }
    });
  }

  // ---------- carona nas respostas de carrinho que o tema ja faz ----------
  function ehUrlDeCarrinho(url) {
    var p = String(url || '').split('?')[0];
    return /\/cart\.js$/.test(p) || /\/cart\/(add|change|update|clear)\.js$/.test(p);
  }

  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var alvo = arguments[0];
    var url = (alvo && alvo.url) ? alvo.url : String(alvo || '');
    var p = fetchOriginal.apply(this, arguments);
    if (ehUrlDeCarrinho(url)) {
      // nunca bloqueia nem altera a promessa original
      p.then(function (res) {
        if (!res || !res.ok) return;
        res.clone().json().then(reconciliar).catch(function () {});
      }).catch(function () {});
    }
    return p;
  };

  // ---------- clique ----------
  function reportar(info) {
    console.warn('[pl-coupon-spot] falha ao aplicar o cupom:', info);
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'pl_coupon_error', endpoint: '/cart/update.js', status: info.status, code: info.code
      });
    } catch (e) {}
  }

  function falha(res) { var e = new Error('HTTP ' + res.status); e.status = res.status; return e; }

  // O `discount` do /cart/update.js SUBSTITUI a lista inteira (doc da Shopify:
  // string vazia remove todos; medido 08/09: aplicar B depois de A deixa so B).
  // Por isso manda os codigos que o carrinho ja tem + o desta etiqueta — mandar
  // so o nosso apagaria o cupom de influenciador que o cliente trouxe por link.
  function aplicar(el) {
    var code = el.getAttribute('data-code');
    if (!code || el.getAttribute('aria-busy') === 'true') return;
    el.setAttribute('aria-busy', 'true');

    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT_MS);
    var sinal = ctrl ? ctrl.signal : undefined;
    var alvo = code.toUpperCase();

    fetchOriginal('/cart.js', {
      credentials: 'same-origin', signal: sinal, headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) { if (!res.ok) throw falha(res); return res.json(); })
      .then(function (cart) {
        var codigos = (cart.discount_codes || [])
          .map(function (d) { return String(d.code || ''); })
          .filter(function (c) { return c && c.toUpperCase() !== alvo; });
        codigos.push(code);
        // `fetch` envelopado: a resposta (o carrinho) passa pelo reconciliar e
        // pinta o estado REAL — se a Shopify recusar o codigo, volta a oferta.
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin', signal: sinal,
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ discount: codigos.join(',') })
        });
      })
      .then(function (res) { if (!res.ok) throw falha(res); })
      // Sem plano B navegando para /discount/: isso gravaria de volta o cookie
      // de 2 semanas. Em falha a oferta continua ali e o cliente clica de novo.
      .catch(function (err) { reportar({ status: err && err.status, code: code }); })
      .finally(function () {
        clearTimeout(timer);
        el.removeAttribute('aria-busy'); // pintarOferta nao limpa quando ja estava em oferta
      });
  }

  // ---------- cookie do mecanismo antigo ----------
  // Quem clicou ANTES de 11/09 ainda carrega `discount_code` com o nosso codigo,
  // e a Shopify seguiria reaplicando o cupom em todo carrinho novo por ate 2
  // semanas. Apaga SO se o valor for exatamente o codigo desta etiqueta: cupom
  // de influenciador que chegou por link nunca e tocado. Se o cookie for
  // HttpOnly o document.cookie nem o enxerga — vira no-op e ele expira sozinho.
  function limparCookieAntigo(code) {
    try {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      if (!m) return;
      var valor = decodeURIComponent(m[1] || '').trim().toUpperCase();
      if (!valor || valor !== String(code || '').toUpperCase()) return;
      var morto = 'discount_code=; Max-Age=0; path=/';
      var host = window.location.hostname;
      document.cookie = morto;
      if (!host) return;
      document.cookie = morto + '; domain=' + host;
      document.cookie = morto + '; domain=.' + host.replace(/^www\./, '');
    } catch (e) {}
  }

  // ---------- init ----------
  function init(el) {
    if (el.__plInit) return;
    el.__plInit = true;
    el.__plOfertaHTML = el.innerHTML; // guarda o markup da oferta p/ poder voltar

    limparCookieAntigo(el.getAttribute('data-code'));

    // primeiro frame sem piscar; o carrinho corrige em seguida se precisar
    if (lembrado(el.getAttribute('data-code'))) pintarAplicado(el);

    el.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.pl-coupon-spot__cta') : null;
      if (!link) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // nova aba continua valendo
      e.preventDefault();
      aplicar(el);
    });
  }

  function boot() { document.querySelectorAll('pl-coupon-spot').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
